import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ToastContainer } from 'react-toastify';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import routes from './routes';
import { PdfPasswordPrompt } from './components/Common/PdfPasswordPrompt';

import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import './index.css'
// primereact
import "primereact/resources/themes/lara-light-blue/theme.css"; // Choose theme
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

const router = createBrowserRouter(routes);

function App() {

  return (
    <div>
      <RouterProvider router={router}></RouterProvider>
      <ToastContainer />
      <PdfPasswordPrompt />
    </div>
  )
}

export default App
